import { get } from 'api/get';
import { post } from 'api/post';
import { buildErrorPayload } from 'state/buildErrorPayload';
import { appendStatus } from 'state/status/actions';

import _ from 'lodash';

export const STATEMENTS_GET_AGGREGATE_RANGE_REQUEST = 'statements/get-aggregate/range/request';
export const STATEMENTS_GET_AGGREGATE_RANGE_SUCCESS = 'statements/get-aggregate/range/success';
export const STATEMENTS_GET_AGGREGATE_RANGE_FAILURE = 'statements/get-aggregate/range/failure';

export const STATEMENTS_GET_PRODUCT_NAMES_REQUEST = 'statements/get-product-names/request';
export const STATEMENTS_GET_PRODUCT_NAMES_SUCCESS = 'statements/get-product-names/success';
export const STATEMENTS_GET_PRODUCT_NAMES_FAILURE = 'statements/get-product-names/failure';

export const STATEMENTS_GET_REPRESENTATIVES_REQUEST = 'statements/get-representatives/request';
export const STATEMENTS_GET_REPRESENTATIVES_SUCCESS = 'statements/get-representatives/success';
export const STATEMENTS_GET_REPRESENTATIVES_FAILURE = 'statements/get-representatives/failure';

export const STATEMENTS_SET_DATERANGE_FILTERS_SUCCESS = 'statements/action/set-daterange-filters/success';

export function getAggregateRange(startDate, endDate, vendorID) {
  return async (dispatch) => {
    dispatch({
      type: STATEMENTS_GET_AGGREGATE_RANGE_REQUEST,
      payload: null
    });

    try {
      const req = await get('statements-aggregate', {
        sd: startDate,
        ed: endDate,
        vID: vendorID
      });
      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: STATEMENTS_GET_AGGREGATE_RANGE_SUCCESS,
        payload: data
      });
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: STATEMENTS_GET_AGGREGATE_RANGE_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}

export function getRepresentatives(startDate, endDate, vendorID) {
  return async (dispatch) => {
    dispatch({
      type: STATEMENTS_GET_REPRESENTATIVES_REQUEST,
      payload: null
    });

    try {
      const req = await get('statements-representatives', {
        sd: startDate,
        ed: endDate,
        vID: vendorID
      });
      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: STATEMENTS_GET_REPRESENTATIVES_SUCCESS,
        payload: data
      });
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: STATEMENTS_GET_REPRESENTATIVES_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}


export function setDateRangeFilter(startDate, endDate, vendorID) {
  return (dispatch) => {
    dispatch({
      type: STATEMENTS_GET_AGGREGATE_RANGE_REQUEST,
      payload: null
    });

    dispatch({
      type: STATEMENTS_SET_DATERANGE_FILTERS_SUCCESS,
      payload: {
        startDate: startDate,
        endDate: endDate,
        vID: vendorID
      }
    });
  };
}

export function getProductGroupData(sourceOrderIds, prodId) {
  return async (dispatch) => {
    dispatch({
      type: STATEMENTS_GET_PRODUCT_NAMES_REQUEST,
      payload: null
    });

    try {
      const req = await post('statements-products', {
        sourceOrderId: sourceOrderIds,
        prodId: prodId
      });

      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: STATEMENTS_GET_PRODUCT_NAMES_SUCCESS,
        payload: data
      });
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: STATEMENTS_GET_PRODUCT_NAMES_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}
